import { PAGINATION, DATE_TIME_FORMAT, IMAGE_DIRECTORY_TYPES, CONFIG_LOCAL_STORAGE, ALL_LANGUAGE_ENUM } from '../constants/Define';
import Config from '../constants/Config';
import { omit, findIndex, find, merge, every } from 'lodash';
import moment from 'moment';
import i18n from './../constants/initLng';
import xssFilters from 'xss-filters';
import * as Sentry from '@sentry/browser';
import classNames from 'classnames';
import { LocalStorage } from '.';

const humanizeDurationFunction = require('./HumanizeDuration');

export const getDummyData = (pageSize = 10, pageIndex = 1, getDataItem, totalCount = 100) => {
    let data = [];
    const max = pageSize * pageIndex;
    const min = max - pageSize;
    for (let i = min; i < max; i++) {
        data.push(getDataItem(i))
    }
    return { data, pageIndex, pageSize, totalCount };
}

export const loadGoogleAPIKey = (key) => {
    return new Promise(resolve => {
        const existingScript = document.getElementById('googleAPI');
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
            script.id = 'googleAPI';
            document.body.appendChild(script);
            script.onload = () => {
                resolve();
            };
        } else {
            resolve();
        }
    });
};

export function parseListRequestParams(params = {}) {
    const PageIndex = params.pageIndex && Number(params.pageIndex) > PAGINATION.pageIndex ? params.pageIndex : undefined;
    const PageSize = params.pageSize && Number(params.pageSize) >= PAGINATION.pageSize ? params.pageSize : undefined;
    const orderBy = params.OrderBy || params.orderBy || undefined;
    const orderByDesc = params.OrderByDesc !== undefined ? params.OrderByDesc : params.orderByDesc !== undefined ? params.orderByDesc : undefined;
    const startDate = params.startDate || params.StartDate ? moment(params.startDate || params.StartDate).toISOString() : undefined;
    const endDate = params.endDate || params.EndDate ? moment(params.endDate || params.EndDate).toISOString() : undefined;
    const isExcludeUserInfo = params.isExcludeUserInfo || false;
    const serialNumber = params.serialNumber || ''
    return {
        ...omit(params, ['pageIndex', 'pageSize', 'OrderBy', 'OrderByDesc']),
        PageIndex, PageSize, orderBy, orderByDesc, startDate, endDate, isExcludeUserInfo, serialNumber
    }
}

export function parseTourListRequestParams(params = {}) {
    return parseListRequestParams(params)
}

export function parseTourLineListRequestParams(params = {}) {
    const fromDate = params.fromDate && params.fromDate.toISOString ? params.fromDate.toISOString() : params.fromDate;
    const toDate = params.toDate && params.toDate.toISOString ? params.toDate.toISOString() : params.toDate;
    return { fromDate, toDate }
}

export function parseOrderVoucherItemDetailListRequestParams(params = {}) {
    const PageIndex = params.pageIndex && params.pageIndex > PAGINATION.pageIndex ? params.pageIndex : undefined;
    const PageSize = params.pageSize && params.pageIndex > PAGINATION.pageIndex ? params.pageSize : undefined;
    const orderBy = params.OrderBy || params.orderBy || undefined;
    const orderByDesc = params.OrderByDesc !== undefined ? params.OrderByDesc : params.orderByDesc !== undefined ? params.orderByDesc : undefined;
    const groupId = params.productVariantId || params.groupId || undefined;
    return {
        ...omit(params, ['pageIndex', 'pageSize', 'OrderBy', 'OrderByDesc', 'productVariantId']),
        PageIndex, PageSize, orderBy, orderByDesc,
        groupId,
    }
}

export function parseListRequestParamsCameo(params = {}) {
    const orderBy = params.OrderBy || params.orderBy || undefined;
    const orderByDesc = params.OrderByDesc !== undefined ? params.OrderByDesc : params.orderByDesc !== undefined ? params.orderByDesc : undefined;
    const startDate = params.startDate ? moment(params.startDate).toISOString() : undefined;
    const endDate = params.endDate ? moment(params.endDate).toISOString() : undefined;
    return {
        ...omit(params, ['OrderBy', 'OrderByDesc', 'totalCount', 'totalPage']),
        startDate, endDate, orderBy, orderByDesc,
        pageIndex: params.pageIndex && Number(params.pageIndex),
        pageSize: params.pageSize && Number(params.pageSize),
    }
}
export function parseListRequestParamsPageNumber(params = {}) {
    const orderBy = params.OrderBy || params.orderBy || undefined;
    const orderByDesc = params.OrderByDesc !== undefined ? params.OrderByDesc : params.orderByDesc !== undefined ? params.orderByDesc : undefined;
    const startDate = params.startDate ? moment(params.startDate).toISOString() : undefined;
    const endDate = params.endDate ? moment(params.endDate).toISOString() : undefined;
    return {
        ...omit(params, ['OrderBy', 'OrderByDesc', 'totalCount', 'totalPage']),
        startDate, endDate, orderBy, orderByDesc,
        pageNumber: params.pageNumber && Number(params.pageNumber),
        pageSize: params.pageSize && Number(params.pageSize),
    }
}
export function parseReportListRequestParams(params = {}) {
    return parseListRequestParamsCameo(params)
}

export function parseRatingListRequestParams(params = {}) {
    return parseReportListRequestParams(params)
}

export function parseTourListReponseParams(data) {
    return {
        pageIndex: data.pageIndex,
        pageSize: data.pageSize,
        totalCount: data.totalCount,
        orderBy: data.orderBy,
        orderByDesc: data.orderByDesc,
        searchTerm: data.searchTerm,
        departure: data.departure,
        destination: data.destination,
        departureDate: data.departureDate,
        fromDate: data.fromDate,
        toDate: data.toDate,
        priceFrom: data.priceFrom,
        priceTo: data.priceTo,
        lengthOfTour: data.lengthOfTour,
    }
}

export function parsePointChangeHistoryListReponseParams(data) {
    return {
        pageIndex: data.pageIndex,
        pageSize: data.pageSize,
        totalCount: data.totalCount,
        orderBy: data.orderBy,
        orderByDesc: data.orderByDesc,
        action: data.action,
        fromAccount: data.fromAccount,
        toAccount: data.toAccount,
        createdBy: data.createdBy,
        orderCode: data.orderCode,
        activityCode: data.activityCode,
        updatedBy: data.updatedBy,
        status: data.status,
    }
}


export function updateObjectInArray(object = {}, array = [], conpareField = 'id') {
    let index = findIndex(array || [], item => object[conpareField] === item[conpareField]);
    if (index >= 0) {
        array[index] = object;
    } else {
        array.push(object);
        index = array.length - 1;
    }
    return array;
}

export function getMomentDate(dateString, format = undefined, convertUTC = true) {
    const utcDate = convertUTC ? moment.utc(dateString, format).toDate() : moment(dateString, format);
    const date = dateString ? moment(utcDate) : undefined;
    return date && date.isAfter(`${DATE_TIME_FORMAT.MINIMUM_YEAR}`, 'year') ? date : undefined;
}

export function updateMomentLocale(locale = Config.DEFAULT_LANG) {
    require(`moment/locale/${locale}.js`);
    let options;
    if (locale === 'vi') {
        options = {
            months: 'Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12'.split('_'),
            weekdays: 'Chủ nhật_Thứ hai_Thứ ba_Thứ tư_Thứ năm_Thứ sáu_Thứ bảy'.split('_'),
        }
    }
    moment.locale(locale, options);
}

export function humanizeDuration(duration, options = {}) {
    options.language = i18n.t('lang');
    options.delimiter = ' ';
    return humanizeDurationFunction(duration, options);
}

export function xssFilter(htmlString) {
    const result = htmlString ? xssFilters.uriComponentInHTMLData(htmlString) : '';
    return decodeURIComponent(result)
}

export function isLocalHost() {
    return /localhost|127\.0\.0\.1|::1|\.local|^$/i.test(window.location.hostname)
}

export function initSentry(key, project) {
    key = key || Config.SENTRY_KEY;
    project = project || Config.SENTRY_PROJECT;
    const isLocal = isLocalHost();
    if (key && project && !isLocal) {
        return Sentry.init({ dsn: `https://${key}@sentry.io/${project}` });
    }
}

export function getLocaleFullName(firstname, lastname) {
    const language = i18n.t('lang');
    const getFullName = (first, last) => {
        return `${first || ''}${last ? (' ' + last) : ''}`
    }
    switch (language) {
        case 'vi':
            return getFullName(lastname, firstname);
        case 'en':
            return getFullName(firstname, firstname);
        default:
            return getFullName(firstname, firstname);
    }
}

export function getImageTypeByDirectory(directory) {
    if (IMAGE_DIRECTORY_TYPES.SLIDE.INCLUDE_DIRECTORIES.includes(directory)) {
        return IMAGE_DIRECTORY_TYPES.SLIDE.id
    }
    return IMAGE_DIRECTORY_TYPES.THUMB.id
}

const MAGIC_BYTES = {
    'image/jpeg': [{ offset: 0, bytes: [0xff, 0xd8, 0xff] }],
    'image/png': [{ offset: 0, bytes: [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a] }],
    'image/gif': [
        { offset: 0, bytes: [0x47, 0x49, 0x46, 0x38, 0x37, 0x61] },
        { offset: 0, bytes: [0x47, 0x49, 0x46, 0x38, 0x39, 0x61] },
    ],
    'application/vnd.ms-excel': [{
        offset: 0,
        bytes: [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1],
    }],
    'video/flv': [{ offset: 0, bytes: [0x46, 0x4c, 0x56] }],
    'video/wmv': [{
        offset: 0,
        bytes: [0x30, 0x26, 0xb2, 0x75, 0x8e, 0x66, 0xcf, 0x11, 0xa6, 0xd9, 0x00, 0xaa, 0x00, 0x62, 0xce, 0x6c],
    }],
};

const MP4_BRANDS = ['isom', 'iso2', 'avc1', 'mp41', 'mp42', 'mmp4'];
const MOV_BRANDS = ['qt  '];
const THREE_GP_BRANDS = ['3gp4', '3gp5', '3gp6', '3gp7', '3gp8', '3gp9'];
const THREE_G2_BRANDS = ['3g2a', '3g2b', '3g2c'];

const matchBytes = (header, bytes, offset = 0) => {
    if (!header || header.length < offset + bytes.length) return false;
    for (let i = 0; i < bytes.length; i += 1) {
        if (header[offset + i] !== bytes[i]) return false;
    }
    return true;
};

const getFtypBrand = (header) => {
    if (!header || header.length < 12) return null;
    if (!matchBytes(header, [0x66, 0x74, 0x79, 0x70], 4)) return null;
    return String.fromCharCode(header[8], header[9], header[10], header[11]);
};

const looksLikeCsv = (text) => {
    if (!text) return false;
    const trimmed = text.trim();
    if (!trimmed) return false;
    const lines = trimmed.split(/\r?\n/).filter(Boolean).slice(0, 5);
    if (!lines.length || lines.length < 2) return false;
    let matched = 0;
    for (let i = 0; i < lines.length; i += 1) {
        if (/[,;\t]/.test(lines[i])) matched += 1;
    }
    return matched >= Math.max(1, Math.floor(lines.length / 2));
};

export const detectMimeFromMagicBytes = (file) => {
    return new Promise((resolve) => {
        if (!file) return resolve(null);
        const reader = new FileReader();
        reader.onload = () => {
            const header = new Uint8Array(reader.result || []);
            const textSample = (() => {
                try {
                    const len = Math.min(header.length, 4096);
                    let str = '';
                    for (let i = 0; i < len; i += 1) {
                        const code = header[i];
                        str += code >= 32 && code <= 126 ? String.fromCharCode(code) : ' ';
                    }
                    return str.toLowerCase();
                } catch (e) {
                    return '';
                }
            })();
            if (textSample.includes('<svg')) return resolve('image/svg+xml');
            const brand = getFtypBrand(header);
            if (brand) {
                if (MP4_BRANDS.includes(brand)) return resolve('video/mp4');
                if (MOV_BRANDS.includes(brand)) return resolve('video/mov');
                if (THREE_GP_BRANDS.includes(brand)) return resolve('video/3gp');
                if (THREE_G2_BRANDS.includes(brand)) return resolve('video/3g2');
            }
            if (matchBytes(header, [0x50, 0x4b, 0x03, 0x04], 0)) {
                return resolve('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            }
            if (looksLikeCsv(textSample)) return resolve('text/csv');
            const magicKeys = Object.keys(MAGIC_BYTES);
            for (let i = 0; i < magicKeys.length; i += 1) {
                const mime = magicKeys[i];
                const signatures = MAGIC_BYTES[mime] || [];
                for (let j = 0; j < signatures.length; j += 1) {
                    const sig = signatures[j];
                    if (matchBytes(header, sig.bytes, sig.offset)) {
                        return resolve(mime);
                    }
                }
            }
            return resolve(null);
        };
        reader.onerror = () => resolve(null);
        reader.readAsArrayBuffer(file.slice(0, 4096));
    });
};

export function parseFlatArrayToTreeData(data = [], parentIdField = 'parentId', childField = 'children', idField = 'id', currentId = undefined) {
    if ((data || []).length && every(data || [], item => !!item[parentIdField])) {
        return data;
    }
    return (data || [])
        .filter(item => item[parentIdField] === currentId)
        .map(item => {
            const newItem = merge(item, { [childField]: parseFlatArrayToTreeData(data || [], parentIdField, childField, idField, item[idField]) });
            if (newItem[childField] && !newItem[childField].length) newItem[childField] = undefined;
            return newItem;
        });
}

export function getModelDefaultLanguage(model) {
    return find(model.languages || [], item => !!item.isDefault);
}

export function readableFileSize(bytes, toFixed = 1, si = false) {
    var thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    var u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(toFixed) + ' ' + units[u];
}

export function getTranslateObject(translations = [], languageCode = undefined, getDefaultOnEmpty = false) {
    return find(translations, item => (languageCode && item.languageCode === languageCode) || (getDefaultOnEmpty && item.isDefault))
}

export function getColumnRenderConfigs(columns, resizeHandler = undefined) {
    return columns && columns.map((col, i) => {
        col.className = (col.className || '').replace('hide', '');
        col.className = classNames(col.className, { hide: col.visible === false })
        col.onHeaderCell = column => ({
            width: column.width,
            fixed: column.fixed,
            columnKey: column.dataIndex !== undefined ? column.dataIndex : column.key,
            onResize: resizeHandler && col.visible !== false && resizeHandler(column, i),
        });
        return col
    });
}

export function getColumnVisibleConfigs(listKeyString, columns = []) {
    if (!listKeyString) return;
    const configs = LocalStorage.get(CONFIG_LOCAL_STORAGE.COLUMN_VISIBLE_CONFIG_PREFIX + ':' + listKeyString) || {};
    columns.forEach((col, index) => {
        const colName = col.dataIndex;
        configs[colName] = configs[colName] || {};
        columns[index] = merge(columns[index], configs[colName])
    });
    return columns;
}

export function setColumnVisibleConfigs(listKeyString, columns = [], configKeys = ['width', 'visible', 'order', 'fixed']) {
    if (!listKeyString) return;
    const configs = {};
    columns.forEach((col, index) => {
        const colName = col.dataIndex;
        configs[colName] = configs[colName] || {};
        configKeys.forEach(key => {
            configs[colName][key] = columns[index][key]
        })
    });
    return LocalStorage.set(CONFIG_LOCAL_STORAGE.COLUMN_VISIBLE_CONFIG_PREFIX + ':' + listKeyString, configs);
}

export function clearColumnVisibleConfigs(listKeyString) {
    if (!listKeyString) return;
    return LocalStorage.remove(CONFIG_LOCAL_STORAGE.COLUMN_VISIBLE_CONFIG_PREFIX + ':' + listKeyString);
}

export function getColumnResizeDisabledConfigs(listKeyString) {
    const config = LocalStorage.get(CONFIG_LOCAL_STORAGE.COLUMN_RESIZE_CONFIG_PREFIX + ':' + listKeyString) || {};
    return config.isDisabled;
}

export function setColumnResizeDisabledConfigs(listKeyString, isDisabled) {
    return LocalStorage.set(CONFIG_LOCAL_STORAGE.COLUMN_RESIZE_CONFIG_PREFIX + ':' + listKeyString, { isDisabled });
}

export function getContentLanguage() {
    return LocalStorage.get(CONFIG_LOCAL_STORAGE.CONTENT_LANGUAGE) || ALL_LANGUAGE_ENUM;
}

export function setContentLanguage(language) {
    return LocalStorage.set(CONFIG_LOCAL_STORAGE.CONTENT_LANGUAGE, language);
}

export function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

export function formatPercentValue(value, maxPercentValue = 100) {
        let valueNumber = Number(value);
    if (!maxPercentValue) return valueNumber;
    if (maxPercentValue && valueNumber > maxPercentValue) {
        valueNumber = maxPercentValue;
    }
    return valueNumber;
}

export function parseInventoryListReponseParams(data) {
    return {
        pageIndex: data.pageIndex,
        pageSize: data.pageSize,
        totalCount: data.totalCount,
    }
}
export const fillHotelNameForRatePlan = ({allHotels = [], dataListRateByHotels = []}) => {
    return [...dataListRateByHotels].map((el) => {
        const hotelFinded = (allHotels || []).find(hotel => hotel.id === el.id);
        return {
            ...el,
            name: hotelFinded?.name || '',
        }
    }) 
}
export const fillHomestayNameForRatePlan = ({allHotels = [], dataListHomestayRateByHomestays = []}) => {
    return [...dataListHomestayRateByHomestays].map((el) => {
        const hotelFinded = (allHotels || []).find(hotel => hotel.id === el.id);
        return {
            ...el,
            name: hotelFinded?.name || '',
        }
    }) 
}
export const fillSupplierNameForProduct = (supplierProducts) => {
    return [...supplierProducts].reduce((suppliers, product) => {
        const existingSupplier = suppliers.find(item => item.id === product.supplierId);

        if (existingSupplier) {
            existingSupplier.productsList.push({
                id: product.id,
                productCode: product.productCode,
                name: product.name
            });
        } else {
            suppliers.push({
                id: product.supplierId,
                name: product.supplierName,
                productsList: [{
                    id: product.id,
                    productCode: product.productCode,
                    name: product.name
                }]
            });
        }

        return suppliers;
    }, []);
}
